import { createAsyncThunk } from '@reduxjs/toolkit';
import UserService from '../../services/UserService';

export const mfaLogin = createAsyncThunk(
  'mfaLogin',
  async (
    arg: { email: string; password: string } | { code: string; state: string },
    { rejectWithValue },
  ) => {
    try {
      const response =
        'state' in arg && 'code' in arg
          ? await UserService.oktaLogin({ code: arg.code, state: arg.state })
          : await UserService.mfaLogin(arg);
      return response.data;
    } catch (err: any) {
      console.log({ status: err.response.status });
      const returnObj = {
        data: err.response.data,
        status: err.response.status,
      };
      return rejectWithValue(returnObj);
    }
  },
);

export const fetchCurrentUser = createAsyncThunk('fetchCurrentUser', async () =>
  UserService.getCurrentUser().then((result) => result.data),
);

export const verifyOTP = createAsyncThunk(
  'verifyOTP',
  async (
    arg: {
      rememberDevice: boolean;
      otp: string;
      mfaLoginToken: string;
    },
    { rejectWithValue },
  ) => {
    try {
      const response = await UserService.multiFactor(arg);
      return response.data;
    } catch (err: any) {
      const returnObj = {
        data: err.response.data,
      };
      return rejectWithValue(returnObj);
    }
  },
);

export const resendOTP = createAsyncThunk(
  'resendOTP',
  async (arg: { mfaLoginToken: string }, { rejectWithValue }) => {
    try {
      const response = await UserService.resendOtp(arg);
      return response.data;
    } catch (err: any) {
      const returnObj = {
        data: err.response.data,
      };
      return rejectWithValue(returnObj);
    }
  },
);

export const login = createAsyncThunk(
  'login',
  async (arg: { email: string; password: string }, { rejectWithValue }) => {
    try {
      const response = await UserService.login(arg);
      return response.data;
    } catch (err: any) {
      const returnObj = {
        data: err.response.data,
      };
      return rejectWithValue(returnObj);
    }
  },
);
